import Ingressinho from 'assets/imgs/ingressinho.svg';
import TrendingEventsCarousel from 'components/TrendingEventsCarousel/TrendingEventsCarousel';
import { analyticsLabels } from 'lib/analytics';

import * as styles from './EmptySearchResults.css';

interface EmptySearchResultsProps {
  title: string;
  subtitle: string;
  description?: string;
  showRecommendation?: boolean;
  hasMargin?: boolean;
}

function EmptySearchResults({
  title,
  subtitle,
  description,
  showRecommendation = false,
  hasMargin = false
}: EmptySearchResultsProps) {
  return (
    <>
      <div
        className={`${styles.Container} ${
          hasMargin ? styles.ContentMargin : ''
        }`}
        data-testid="empty-search"
      >
        <Ingressinho width={80} height={80} className={styles.ImgStyle} />
        <h3 className={styles.Title}>{title}</h3>
        <p className={styles.TextStyle}>{subtitle}</p>
        {description && <p className={styles.TextStyle}>{description}</p>}
      </div>
      {showRecommendation && (
        <TrendingEventsCarousel
          pageTitleForTracking={analyticsLabels.pageWithNoResults}
        />
      )}
    </>
  );
}

export default EmptySearchResults;
